'use strict'

import EventEmitter from 'tiny-emitter'

const DATE_FROM_NOW_EVENT = 'tick'
const MINUTES = 60 * 1000
const DATE_FROM_NOW_INTERVAL = 3 * MINUTES

let intervalCount = 0
let interval

/**
 * Controller for the dateFromNow component.
 *
 * @class DateFromNowController
 */
class DateFromNowController {
  constructor($interval, vdDateFromNowFilter) {
    this._$interval = $interval
    this._vdDateFromNowFilter = vdDateFromNowFilter

    /**
     * Update the dateFromNow date/time.
     *
     * @method _updateDateTime
     */
    this._updateDateTime = () => {
      this.dateFromNow = this._vdDateFromNowFilter(this.date)
    }
  }

  $onChanges() {
    this._updateDateTime()
  }

  $onInit() {
    if (intervalCount === 0) {
      // Create a single $interval instance
      const emitter = new EventEmitter()
      const timer = this._$interval(
        () => emitter.emit(DATE_FROM_NOW_EVENT),
        DATE_FROM_NOW_INTERVAL
      )
      interval = { emitter, timer }
    }

    interval.emitter.on(DATE_FROM_NOW_EVENT, this._updateDateTime)
    intervalCount += 1
  }

  $onDestroy() {
    interval.emitter.off(DATE_FROM_NOW_EVENT, this._updateDateTime)
    intervalCount -= 1

    if (intervalCount === 0) {
      this._$interval.cancel(interval.timer)
      interval = null
    }
  }
}

DateFromNowController.$inject = ['$interval', 'vdDateFromNowFilter']

export default DateFromNowController
